function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingConditions7 = function SvgLandingConditions7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 503 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_26_6570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.658 72.9224C171.681 43.6941 260.355 79.997 319.717 154.007C379.079 228.017 295.605 350.222 245.583 379.45C195.56 408.679 201.864 284.145 142.502 210.135C10.9304 165.343 71.6356 102.151 121.658 72.9224Z",
    fill: "#4DB7FE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_26_6570)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.463,
    cy: 276.57,
    rx: 145.559,
    ry: 47.6926,
    transform: "rotate(63.5532 202.463 276.57)",
    fill: "#F12EFF",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter2_f_26_6570)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.8569,
    cy: 102.09,
    rx: 94.8569,
    ry: 102.09,
    transform: "matrix(-0.428405 -0.903587 0.988728 -0.149726 260.614 326.55)",
    fill: "#139000"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_26_6570",
    x: 0.767387,
    y: 0.386772,
    width: 401.878,
    height: 445.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.2127,
    result: "effect1_foregroundBlur_26_6570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_26_6570",
    x: 51.4165,
    y: 71.0941,
    width: 302.092,
    height: 410.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.705,
    result: "effect1_foregroundBlur_26_6570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_26_6570",
    x: 139.685,
    y: 66.0847,
    width: 362.461,
    height: 318.936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.1948,
    result: "effect1_foregroundBlur_26_6570"
  }))));
};
export default SvgLandingConditions7;